/* ============================================================================
 * NotBuilt — the honest state for a desk the design source specifies but this
 * repo has not implemented yet.
 * ----------------------------------------------------------------------------
 * Five desks are in that position (home-office, reserve-capital, calendar,
 * community, vendor). Rather than hide them from the dock — which would make
 * the OS look smaller than the product is — they are registered, shown, and say
 * plainly what they are and where the design lives.
 * ========================================================================= */

import { DESIGN_SOURCE, type AppDef } from './registry';
import { SkinArt } from '../components/SkinArt';

export function NotBuilt({ app }: { app: AppDef }) {
  return (
    <div className="stack">
      <div className="hstack" style={{ alignItems: 'center', gap: 10 }}>
        <SkinArt
          src={app.tile}
          alt=""
          aria-hidden="true"
          width={40}
          height={40}
          style={{ imageRendering: 'pixelated' }}
        />
        <div className="stack" style={{ gap: 2 }}>
          <span className="eyebrow">desk not implemented</span>
          <span style={{ fontSize: 15 }}>{app.label}</span>
        </div>
      </div>

      <hr className="rule" />

      <p className="note">
        <strong>Specified in the design source, not yet built here.</strong> This
        desk exists as a designed screen; there is no React implementation yet,
        so there is nothing to show.
      </p>

      <div className="panel">
        <div className="row">
          <span className="row__k">Desk id</span>
          <span className="row__v mono">{app.id}</span>
        </div>
        <div className="row">
          <span className="row__k">Scope</span>
          <span className="row__v">{app.blurb}</span>
        </div>
        <div className="row">
          <span className="row__k">Design source</span>
          <span className="row__v mono">
            {DESIGN_SOURCE.repo}/{DESIGN_SOURCE.file(app.id)}
          </span>
        </div>
        <div className="row">
          <span className="row__k">Status</span>
          <span className="row__v">
            <span className="tag tag--warn">NOT BUILT</span>
          </span>
        </div>
      </div>

      <p className="note">
        Open the design source to see the intended screen. This window is a
        placeholder that names the gap — it is not a mock of the desk.
      </p>
    </div>
  );
}
